// extracted by mini-css-extract-plugin
module.exports = {"selectedCrossIcon":"multiselector_selectedCrossIcon__3p-bW","selectedLi":"multiselector_selectedLi__3EQms"};